export const FETCHING_PARTNERS = 'FETCHING_PARTNERS';
export const FETCHING_PARTNERS_DEFAULT = 'FETCHING_PARTNERS_DEFAULT';
export const FETCHING_PARTNER = 'FETCHING_PARTNER';
export const CREATING_PARTNER = 'CREATING_PARTNER';
export const UPDATING_PARTNER = 'UPDATING_PARTNER';
export const DELETING_PARTNER = 'DELETING_PARTNERS';
export const FETCHING_ETABLISSEMENTS = 'FETCHING_ETABLISSEMENTS';
export const CREATING_ETABLISSEMENT = 'CREATING_ETABLISSEMENT';
export const UPDATING_ETABLISSEMENT = 'UPDATING_ETABLISSEMENT';
export const DELETING_ETABLISSEMENT = 'DELETING_ETABLISSEMENT';
export const GENERATING_ETABLISSEMENT_API_KEY = 'GENERATING_ETABLISSEMENT_API_KEY';
export const FETCHING_USERS = 'FETCHING_USERS';
export const CREATING_USER = 'CREATING_USER';
export const UPDATING_USER = 'UPDATING_USER';
export const DELETING_USER = 'DELETING_USER';
export const SENDING_USER_ACTIVATION = 'SENDING_USER_ACTIVATION';
export const UPLOADING_LOGO = 'UPLOADING_LOGO';